<h2>
  {{ "Interested" | translate }}
</h2>

<form [formGroup]="interestinForm">
  <div>
    <label>
      {{ "Name" | translate }}
    </label>
    <input formControlName="name" type="text" />
    <p *ngIf="isFieldValid('name')" i18n>
      *{{ "Name is required" | translate }}
    </p>
  </div>
  <div>
    <label>
      {{ "Email" | translate }}
    </label>
    <input formControlName="email" type="email" />
    <p *ngIf="isFieldValid('email')" i18n>
      *{{ "Enter valid email Ex" | translate }}: user@domain.com
    </p>
  </div>
  <div>
    <label>
      {{ "Phone" | translate }}
    </label>
    <input formControlName="phone" type="text" />
    <p *ngIf="isFieldValid('phone')" i18n>
      *{{ "Phone is required" | translate }}
    </p>
  </div>
  <div>
    <label>
      {{ "Message" | translate }}
    </label>
    <textarea formControlName="message" type="text"></textarea>
    <p *ngIf="isFieldValid('message')" i18n>
      *{{ "Message is required and at least 10 characters" | translate }}
    </p>
  </div>
  <div class="button">
    <button (click)="intersting()">
      {{ "submit" | translate }}
    </button>
  </div>
</form>
